import { forwardRef } from "react";
import { createTheme } from "@mui/material";
import { LinkProps } from "@mui/material/Link";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router-dom";

const LinkBehavior = forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, "to"> & { href: RouterLinkProps["to"] }>(
	(props, ref) => {
		const { href, ...other } = props;
		return <RouterLink ref={ref} to={href} {...other} />;
	}
);

export const theme = createTheme({
	palette: {
		primary: {
			main: "#6A040F",
			light: "#FEE8E8",
			dark: "#6A040F"
		},
		secondary: {
			main: "#ED766E"
		},
		success: {
			main: "#43A047",
			contrastText: "white",
			light: "#E8F5E9"
		},
		error: {
			main: "#E53935",
			light: "#FEEBEE"
		},
		warning: {
			main: "#FFB300",
			contrastText: "white",
			light: "#FFECB3"
		},
		info: {
			main: "#388DFF",
			contrastText: "white",
			light: "#E0F0FF",
			dark: "#1F53AF"
		},
		text: {
			primary: "#3D3D3D"
		}
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 576,
			md: 768,
			lg: 992,
			xl: 1200
		}
	},
	typography: {
		fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`
	},
	components: {
		MuiLink: {
			defaultProps: {
				component: LinkBehavior
			} as LinkProps
		},
		MuiButtonBase: {
			defaultProps: {
				LinkComponent: LinkBehavior
			}
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: "none"
				}
			}
		}
	}
});
